import {confirmAction} from 'actions/commonActions';
import {getCurrentUser, resendConfirmationEmail, toggleEmailConfirmation} from 'actions/userActions';
import Navigation from 'components/Navigation';
import {PENDING_USER_STATUS} from 'constants/userStatuses';
import uiHelper from 'helpers/uiHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, {useEffect} from 'react';
import Helmet from 'react-helmet';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import {navPanelWidth} from 'styles/shared';

const PageContainer = styled.div`
  display: flex;
`;

const ChildContainer = styled.div`
  position: absolute;
  width: calc(100% - ${navPanelWidth});
  height: 100%;
  left: ${navPanelWidth};
  top: 0;
  bottom: 0;
  background: white;
  box-shadow: -1.5rem 0.4rem 8.4rem rgba(0, 0, 0, 0.06);
  padding: 0 8rem;
  border-top-left-radius: 8rem;
  border-bottom-left-radius: 8rem;
  display: flex;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
`;

const AuthContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: white;
`;

AppPage.propTypes = {
  children: PropTypes.object.isRequired,
  title: PropTypes.string
};

function AppPage(props) {
  let dispatch = useDispatch();
  let history = useHistory();

  const user = useSelector((state: any) => state.user.current);
  const showEmailConfirmation = useSelector((state: any) => state.user.showEmailConfirmation);

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function initData() {
    if (isAuthenticated()) {
      showConfirmation(user?.status);
      return;
    }

    let currentUser: any = await dispatch(getCurrentUser());

    if (!currentUser) return history.push('/login');

    showConfirmation(currentUser?.status, true);
  }

  function showConfirmation(status, reload = false) {
    let isVisible = reload ? true : showEmailConfirmation;

    let isPendingStatus = status === PENDING_USER_STATUS;

    //FIXME: decide if we should remove popup definitively
    isPendingStatus = false;

    if (!isPendingStatus || !isVisible) return;

    dispatch(
      confirmAction({
        title: 'Resend Confirmation Email',
        text: 'User email is not confirmed. Resend confirmation email?',
        action: async () => {
          let response: any = await dispatch(resendConfirmationEmail());

          if (response && response.success) {
            uiHelper.showMessage('Confirmation email was sent.');
            dispatch(toggleEmailConfirmation());
          }
        },
        close: async () => {
          await dispatch(toggleEmailConfirmation());
        }
      })
    );
  }

  function isAuthenticated() {
    if (props.public) return true;
    return !_.isEmpty(user);
  }

  function getTitle() {
    return props.title ? `Travel Advice - ${props.title}` : 'Travel Advice';
  }

  function isReady() {
    return isAuthenticated();
  }

  function render() {
    if (!isReady()) return null;

    const publicMode = props.public;

    let title = getTitle();

    return (
      <PageContainer>
        <Helmet title={title} />

        {!publicMode && <Navigation />}

        {publicMode ? (
          <AuthContainer>{props.children}</AuthContainer>
        ) : (
          <ChildContainer>{props.children}</ChildContainer>
        )}
      </PageContainer>
    );
  }

  return render();
}

export default AppPage;
